import React, { ReactNode } from 'react'
import * as S from '../style'
import Svg from '@components/svg'
import { totalusers } from '@assets/icons'

const SearchInput = ({
  searchInput,
  setSearchInput,
  placeholder,
  hasButton = false,
  buttonLabel = 'Export',
  onButtonClick,
  icon,
  styleSearchLeftText,
  text,
  styleText,
  hasChildren,
  children,
  rightSearchElement,
}: {
  searchInput: string
  setSearchInput: (val: string) => void
  placeholder: string[]
  hasButton?: boolean
  buttonLabel?: string
  onButtonClick?: () => void
  icon?: string
  hasText?: boolean
  text?: string
  styleText?: React.CSSProperties
  hasChildren?: boolean
  children?: ReactNode
  styleSearchLeftText?: string
  rightSearchElement?: ReactNode
}) => {
  return (
    <S.StyleTableSearchWrapper>
      {!!text && (
        <S.Text style={{ ...styleText }}>
          <Svg src={icon} styleSvg="transform:translateY(1px)" />
          {text}
        </S.Text>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        {!!rightSearchElement && <div>{rightSearchElement}</div>}
        <S.SearchInputWrapper>
          <S.StyleSearchIcon />
          <S.StyleTableSearchInput
            type="text"
            placeholder={'Search by: ' + placeholder.join(' or ')}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </S.SearchInputWrapper>
      </div>
    </S.StyleTableSearchWrapper>
  )
}

export default SearchInput
